import React, {useState} from 'react'
import {Button, Modal} from 'antd'
import SingleUserBuilder from './SingleUserBuilder'

export default function AddUserButton({success, className, style}) {
  const [done, setDone] = useState(false)
  const [show, setShow] = useState(null)

  return (
    <div>
      <Button className={className} style={style} onClick={() => setShow(true)}>
        Add User
      </Button>
      <Modal
        width={'80%'}
        onCancel={() => {
          setDone('clear')
          setShow(false)
        }}
        onOk={() => {
          setDone('done')
          success.map((f) => f())
          setShow(false)
        }}
        visible={show}
      >
        <SingleUserBuilder setDone={setDone} done={done} />
      </Modal>
    </div>
  )
}
